import { Dispatch, SetStateAction, useState, useEffect, useCallback } from 'react';
import s from './index.module.scss';
import { useTranslation } from 'react-i18next';
import Img from '@/component/Img';
import OneLinkImg from '@/component/wing/OneLinkImg';
import cx from 'classnames';
import { generateSignature } from '@/util/signature';
import { Stage } from '../const';
import { useToast } from '@/stores/ToastContext';
import { postApi } from '@/util/request';
import { useRouter } from 'next/router';
import CountDown from '../../../../commonComponents/countDown';
import VerificationInput from './verificationInput';

export default function Phone(props: {
    setStage: Dispatch<SetStateAction<number>>,
    countryCode: string,
    mobileNumber: string,
}) {
  const { t } = useTranslation();
  const router = useRouter();
  const { setStage, countryCode, mobileNumber } = props;

  const [confirmActive, setConfirmActive] = useState(false);
  const [countDown, setCountDown] = useState(true);
  const [code, setCode] = useState<number>();
  const showToast = useToast();

  const onVerify = async () => {
    if (!(String(code)?.length === 6)) {
      return;
    }
    const res = await postApi(`${window.location.protocol}//${window.location.host}/web/login`, {
      grantType: 'phone', // 类型可能为：phone，email
      countryCode: Number(countryCode),
      mobileNumber,
      code,
    });
    // 已有账号
    if (res.meta?.code === 200) {
      document.cookie = `access-token=${res.data?.token}`;
      return router.push('/swip');
    } else if (res.meta?.code === 40014) {
      showToast(t('DUET_H5_ACCOUNT_MANAGE_CODE_ERROR_TOAST'));
    } else {
      showToast(t('DUET_WEB_SIGNIN_NUMBER_WRONG_TOAST'));
    }
  };


  const onComplete = useCallback((inputs) => {
    setCode(Number(inputs?.join('')));
  }, []);

  useEffect(() => {
    setConfirmActive(String(code)?.length === 6);
  }, [code]);

  const handleSendAgain = useCallback(async () => {
    if (countDown) return;
    // return router.push('/logEntries/varifyPhone');
    const token = await (window as any).grecaptcha.enterprise.execute(process.env.RECAPTCHA_SITE_KEY, { action: 'submit' });
    const res = await fetch(`${window.location.protocol}//${window.location.host}/api/confirmation-code?token=${token}`, {
      method: 'POST',
      body: JSON.stringify({
        mobileNumber,
        grantType: 'phone',
        countryCode: Number(countryCode),
        signature: generateSignature('phone', '', countryCode, mobileNumber),
      }),
    });
    if (res.ok) { // 检查响应是否成功
      setCountDown(true);
    } else {
      showToast(t('DUET_H5_ACCOUNT_MANAGE_REQUEST_MAX_ERROR_TOAST'));
    }
  }, [countDown, countryCode, mobileNumber]);

  const onCodeChange = (value) => {
    if (value?.join('').length === 4) {
      setConfirmActive(true);
    } else {
      setConfirmActive(false);
    }
  };

  return (

    <>
      <div className={s.icon} />
      <div className={s.title}>{t('DUET_WEB_SIGNIN_OTP_TITLE')}</div>
      <div className={s.sendAgainWrapper}>
        <div className={s.number}>+{countryCode} {mobileNumber}</div>
        <div className={cx(s.sendAgain, { [s.countDown]: countDown })} onClick={handleSendAgain}>
          {countDown ? <CountDown seconds={45} endfix="s" onEnd={() => setCountDown(false)} />
            : t('DUET_WEB_SIGNIN_OTP_RESEND')}
        </div>

      </div>
      <VerificationInput
        onComplete={onComplete}
        // className={invalidCode ? s.invalid : null}
        onChange={onCodeChange}
      />
      <div className={s.changeNumber} onClick={() => setStage(Stage.Phone)}>{t('DUET_WEB_SIGNIN_OTP_CHANGENUMBER')}</div>
      <div
        className={cx(s.button, { [s.active]: confirmActive })}
        onClick={onVerify}
      >{t('DUET_H5_ACCOUNT_MANAGE_PHONE_LOGIN_NUMBER_PAGE_NEXT_BUTTON')}
      </div>
    </>
  );
}
